/* eslint-disable @typescript-eslint/no-explicit-any */
import { ComponentType } from 'react'

/**
 * This function handles the dynamic lazy loading of the components
 * Includes:
 *  * 300 milliseconds initial delay (allows skeleton to render before fetch starts)
 *  * Up to 5 load retries with exponential backoff (1s, 2s, 4s, 8s)
 *
 * Accepts a factory function so each retry triggers a fresh import() network request.
 * */
export const lazyLoadHelper = async (
  importFactory: () => Promise<{ default: ComponentType<any> }>,
  retriesLeft = 5,
  interval = 1000
): Promise<{ default: ComponentType<any> }> => {
  await new Promise<void>((resolve) => {
    setTimeout(resolve, 300)
  })

  return new Promise<{ default: ComponentType<any> }>((resolve, reject) => {
    importFactory()
      .then(resolve)
      .catch((error) => {
        if (retriesLeft === 1) {
          reject(error)
          return
        }
        setTimeout(() => {
          lazyLoadHelper(importFactory, retriesLeft - 1, interval * 2).then(
            resolve,
            reject
          )
        }, interval)
      })
  })
}
